module.exports = __webpack_public_path__ + "static/media/festival_hover.66cd8a7f.jpg";